module.exports = __webpack_public_path__ + "img/mingbai1_b8c87c030.png";